import { useEffect, useState } from "react";
import { Moon, Sun } from "lucide-react";

const getTheme = () => (document.documentElement.dataset.theme === "dark" ? "dark" : "light");

export const ThemeToggle = ({ className = "" }) => {
  const [theme, setTheme] = useState(getTheme);

  useEffect(() => {
    const mq = window.matchMedia("(prefers-color-scheme: dark)");
    const onChange = () => {
      try {
        if (!localStorage.getItem("theme")) setTheme(getTheme());
      } catch (e) {}
    };
    const onAuto = () => setTheme(getTheme());
    mq.addEventListener("change", onChange);
    window.addEventListener("theme-auto-change", onAuto);
    return () => {
      mq.removeEventListener("change", onChange);
      window.removeEventListener("theme-auto-change", onAuto);
    };
  }, []);

  const toggle = () => {
    const next = theme === "dark" ? "light" : "dark";
    document.documentElement.dataset.theme = next;
    try {
      localStorage.setItem("theme", next);
    } catch (e) {}
    setTheme(next);
  };

  useEffect(() => {
    const onRequest = () => toggle();
    window.addEventListener("theme-toggle-request", onRequest);
    return () => window.removeEventListener("theme-toggle-request", onRequest);
  });

  return (
    <button
      type="button"
      onClick={toggle}
      data-testid="theme-toggle"
      aria-label={theme === "dark" ? "Přepnout na světlý režim" : "Přepnout na tmavý režim"}
      title={theme === "dark" ? "Světlý režim" : "Tmavý režim"}
      className={`p-2 text-[#737373] hover:text-[#B69A58] transition-colors duration-300 ${className}`}
    >
      {theme === "dark" ? (
        <Sun className="h-5 w-5" strokeWidth={1.5} />
      ) : (
        <Moon className="h-5 w-5" strokeWidth={1.5} />
      )}
    </button>
  );
};
